import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Topic from './topic';
import BannerPic from './bannerPic';
import Headline from './headline';
import NewsLive from './newsLive';

class LeftContent extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return (
            <div className={styles.col_L}>
                <Topic />
                {content.bannerPic && content.bannerPic.length > 0 ? (
                    <Chip
                        id="30028"
                        type="struct"
                        title="焦点图广告权益"
                        groupName="焦点图广告权益"
                        position="relative"
                        content={content.bannerPic}>
                        <BannerPic />
                    </Chip>
                ) : (
                    ''
                )}
                <Headline content={content.headline} rights={content.rights} />
                <NewsLive content={content.newsLive} />
            </div>
        );
    }
}

export default LeftContent;
